import React from 'react';

import classNames from 'classnames';
import { Link } from '@ergeon/core-components';

import { FooterTermsProps } from './types';

const TERMS_CLASSES = classNames(
  'flex flex-col gap-4 border-t border-gray-200 pt-8 dark:border-gray-800',
  'md:flex-row md:items-center md:justify-between',
);

const FooterTerms: React.FC<FooterTermsProps> = ({ ergeonUrl }) => {
  const currentYear = new Date().getFullYear();

  return (
    <div className={TERMS_CLASSES}>
      <p className="paragraph-3 text-gray-600 dark:text-gray-400">
        &copy; {currentYear} Ergeon Inc. All rights reserved.
      </p>
      <div className="flex items-center gap-4">
        <Link className="paragraph-3" href={`${ergeonUrl}/terms`}>
          Terms of Service
        </Link>
        <Link className="paragraph-3" href={`${ergeonUrl}/privacy`}>
          Privacy Policy
        </Link>
      </div>
    </div>
  );
};

export default FooterTerms;
